import { render, staticRenderFns } from "./fileImage.vue?vue&type=template&id=22e89538&scoped=true"
import script from "./fileImage.vue?vue&type=script&lang=js"
export * from "./fileImage.vue?vue&type=script&lang=js"
import style0 from "./fileImage.vue?vue&type=style&index=0&id=22e89538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e89538",
  null
  
)

export default component.exports